import { render, staticRenderFns } from "./ProjectComments.vue?vue&type=template&id=2e00fb36"
import script from "./ProjectComments.vue?vue&type=script&lang=js"
export * from "./ProjectComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports